/**
 * @file PlaygroundBlock.js
 * @description Extracted from ProjectSidebar: renders the Image/Video playground blocks.
 * Pixel-perfect: DOM structure, class names, and content mirror the original markup exactly.
 */
import React from 'react';


export default function PlaygroundBlock({
  title,
  blockClassName,   // e.g., "playground-images fixed-pos" or "playground-videos fixed-pos"
  items,            // array or null (for loading)
  kind,             // 'image' | 'video'
  onPlusClick,      // handler for the "+" button
  onOpenArtifact,    // (artifact, kind) => void
  onArtifactContextMenu // (e, kind, artifact) => void
}) {

  return (
    <div className={`playground-block ${blockClassName}`}>
      <div className="playground-header">
        <span>{title}</span>
        <button className="playground-plus" onClick={onPlusClick}>+</button>
      </div>
      <div className="playground-scroll">
        <ul className="artifact-sublist">
          {(items || []).map((a) => (
            <li key={a._id || a.id} className="artifact-subitem">
              <a
                href="#"
                className="artifact-chip"
                title={a.title || (kind === 'image' ? 'image' : 'video')}
                onClick={(e) => { e.preventDefault(); onOpenArtifact && onOpenArtifact(a, kind); }}
                onContextMenu={(e) => {
                  if (onArtifactContextMenu) {
                    onArtifactContextMenu(e, kind, a);
                  }
                }}
              >
                <span className="thumb-wrap">
                  {kind === 'image'
                    ? ((a.outputUrl || a.inputImageUrl)
                      ? <img src={a.outputUrl || a.inputImageUrl} alt={a.title || 'image'} />
                      : <span className="thumb-fallback">IMG</span>)
                    : kind === 'video'
                      ? (a.thumbnailUrl
                        ? <img src={a.thumbnailUrl} alt={a.title || 'video'} />
                        : <span className="thumb-fallback">🎞</span>)
                      : (/* Audio */
                        // Check heuristic (same as Workbench)
                        ((a.model && a.model.includes('tts')) || (a.modality === 'text-to-speech'))
                          ? <img
                            src={`${process.env.PUBLIC_URL}/speech-icon.png`}
                            alt="Speech"
                            style={{ width: '76%', height: '76%', objectFit: 'contain', filter: 'invert(1)', margin: 'auto', mixBlendMode: 'screen', clipPath: 'inset(0 8% 0 0)' }}
                          />
                          : <span className="thumb-fallback" style={{ fontSize: '1.6vh' }}>♫</span>
                      )
                  }
                </span>
                <span className="chip-title">{a.title || (kind === 'image' ? 'Untitled image' : kind === 'video' ? 'Untitled video' : 'Untitled audio')}</span>
              </a>
            </li>
          ))}
          {items === null ? (
            <li className="artifact-empty">Loading…</li>
          ) : ((items || []).length === 0 && (
            <div className="artifact-empty-state" onClick={onPlusClick}>
              {kind === 'image' ? (
                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              ) : kind === 'video' ? (
                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              ) : (
                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19V6l12-3v13M9 19a3 3 0 10-2.995-3.004M21 16a3 3 0 10-3 3" />
                </svg>
              )}
              <span>{kind === 'image' ? 'Create your first image' : kind === 'video' ? 'Create your first video' : 'Create your first audio'}</span>
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
}
